var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "var(--icon-stroke-width, 1.5)",
    d: "m1 5.654 8.156 6.274c.497.382 1.19.382 1.688 0L19 5.654m0 0v9.692c0 .765-.62 1.385-1.385 1.385H2.385C1.62 16.73 1 16.11 1 15.346V5.654c0-.765.62-1.385 1.385-1.385h15.23c.765 0 1.385.62 1.385 1.385Z"
  })));
};
export default SvgMail;